import React, { useState, useEffect } from 'react';
import { ArrowRight, Save, Upload, Plus, Trash2, ChevronDown, Video, User, ArrowLeft, Edit2, X, GripVertical, Lock, Unlock, Star } from 'lucide-react';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";


import { getFirestore, doc, updateDoc, getDoc } from "firebase/firestore"; // Client-side Firestore imports
import { firestore } from './firebase'; // Assuming firestore is initialized in firebase.js



import { storage, auth, signOut, onAuthStateChanged } from './firebase'; // Adding auth and onAuthStateChanged
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import './CustomStyles.css';
import CategoriesPage from './eApp_CategoriesPage';
import Modal from './eApp_Modal';
import EditableText from './eApp_EditableText';
import VideoThumbnail from './eApp_VideoThumbnail';
import VideoPage from './eApp_VideoPage';
import AccountPage from './AccountPage';  // Same reference as ClientApp
import Login from './Login';  // Importing the login component
import videosData from './eApp_Videos';

import { 
  eApp_handleSelectVideo,
  eApp_handleBackToCategories,
  eApp_handleEditVideo,
  eApp_handleAddVideo,
  eApp_handleDeleteVideo,
  eApp_handleAddCategory,
  eApp_handleDeleteCategory,
  eApp_handleReorderCategories,
  eApp_handleToggleLockVideo,
  eApp_handleToggleNewVideo,
  eApp_handleReorderVideos,
  eApp_handleSortEnd
} from './eApp_Handlers';




const REACT_APP_VERSION = 'editor';  
console.log('REACT_APP_VERSION:', REACT_APP_VERSION);





const colors = {
  background: '#FAFAFA',
  primary: '#F0EAE2',
  secondary: '#E0E0E0',
  text: '#333333',
  lightText: '#666666',
  cardBg: '#FFFFFF',
};




// EditorApp.js









// Adding state for login and user authentication
const EditorApp = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null); // New state to track the user
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showAccount, setShowAccount] = useState(false);
  const [categories, setCategories] = useState(['Beginner Yoga', 'Intermediate Flows', 'Advanced Practices']);
  const [videos, setVideos] = useState(videosData);

  const [isSaleActive, setIsSaleActive] = useState(false);  // State for sale toggle
  const [saleName, setSaleName] = useState('');  // State for sale name
  const handleSortEnd = eApp_handleSortEnd(setVideos);


  
  const handleEditVideo = (category, index, updatedVideo) => {
    setVideos((prevVideos) => ({
      ...prevVideos,
      [category]: prevVideos[category].map((video, i) => (i === index ? updatedVideo : video)),
    }));
    // Update selectedVideo if necessary
    if (selectedVideo && selectedVideo.id === updatedVideo.id) {
      setSelectedVideo(updatedVideo);
    }
  };




  // Toggle sale on/off
  const handleSaleToggle = () => {
    setIsSaleActive(!isSaleActive);
  };

  // Function to handle sale name change
  const handleSaleNameChange = (e) => {
    setSaleName(e.target.value);
  };


  // Handling authentication on component mount
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setIsLoggedIn(!!user);
      if (user) {
        setUserId(user.uid);

        // Refresh the token to make sure it's valid
        try {
          await user.getIdToken(true);  // Refresh the token before fetching data
          const fetchData = async () => {
            try {
              const storageRef = ref(storage, 'viewer_app_data.json');
              const url = await getDownloadURL(storageRef);
              console.log('Fetching JSON from:', url); // Log the URL
              const response = await fetch(url);
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              const data = await response.json();
              console.log('Fetched data:', data); // Log the fetched data
              setCategories(data.categories);
              setVideos(data.videos);
            } catch (error) {
              console.error('Error fetching JSON:', error);
            }
          };

          fetchData();
        } catch (error) {
          console.error('Error refreshing token:', error);
        }
      } else {
        setUserId(null);
      }
    });

    return () => unsubscribe();
  }, []);


  // Function to handle logging out
  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsLoggedIn(false);
    } catch (error) {
      console.error("Sign Out Error:", error);
    }
  };

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleAccountClick = () => {
    setShowAccount(true);
  };

  const handleSave = () => {
    const data = JSON.stringify({ categories, videos }, null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'yoga_app_data.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  // Correct place for the handlePublish function

  const handlePublish = async () => {
    try {
      const data = JSON.stringify({ categories, videos }, null, 2);
      const blob = new Blob([data], { type: 'application/json' });
      const storageRef = ref(storage, 'viewer_app_data.json');
      const uploadTask = uploadBytesResumable(storageRef, blob);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Handle progress, if needed
        },
        (error) => {
          console.error("Upload failed:", error);
          alert('Failed to publish data.');
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          console.log("File published to Firebase:", downloadURL);

          // Update sale settings in Firestore
          const saleSettingsRef = doc(firestore, 'settings/discountSettings');
          await updateDoc(saleSettingsRef, {
            isDiscountActive: isSaleActive,
            saleName: isSaleActive ? saleName : '',  // Only send saleName if sale is active
          });

          alert('Data and Sale settings published successfully!');
        }
      );
    } catch (error) {
      console.error('Error publishing JSON:', error);
      alert('Failed to publish data.');
    }
  };





  const handleExport = () => {
    const data = JSON.stringify({ categories, videos }, null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'viewer_app_data.json';
    a.click();
    URL.revokeObjectURL(url);

    // Upload JSON to Firebase Storage
    const storageRef = ref(storage, 'viewer_app_data.json');
    const uploadTask = uploadBytesResumable(storageRef, blob);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Handle progress
      },
      (error) => {
        console.error("Upload failed:", error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
        });
      }
    );
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const importedData = JSON.parse(event.target.result);
      setCategories(importedData.categories);
      setVideos(importedData.videos);
    };
    reader.readAsText(file);
  };

  const handleImportLatest = async () => {
    try {
      const storageRef = ref(storage, 'viewer_app_data.json');  
      const url = await getDownloadURL(storageRef);  
      const response = await fetch(url);  
      if (!response.ok) throw new Error('Network response was not ok');

      const importedData = await response.json();  
      setCategories(importedData.categories);  
      setVideos(importedData.videos);  
      
      // Fetch the latest sale settings from Firestore
      const saleSettingsRef = doc(firestore, 'settings/discountSettings');
      const saleDoc = await getDoc(saleSettingsRef);

      if (saleDoc.exists()) {
        const saleData = saleDoc.data();
        setIsSaleActive(saleData.isDiscountActive || false);  // Update sale toggle
        setSaleName(saleData.saleName || '');  // Update sale name
      } else {
        console.log("No sale settings document found");
      }

      alert('Latest data and sale settings imported successfully!');
    } catch (error) {
      console.error('Error fetching JSON or sale settings:', error);
      alert(`Failed to import latest data: ${error.message}`);
    }
  };



  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  // Placeholder for lock image URL from Firebase
  const lockImageUrl = 'https://firebasestorage.googleapis.com/v0/b/yogaapp-7dd5d.appspot.com/o/thumbnails%2FLock_SmallIMG.jpg?alt=media&token=3bb8cba1-b38e-4295-94f7-06c5dc7b3dbe';

  return (
    <div className="min-h-screen editor-app">
      <div className="p-4 bg-[#F0EAE2] text-[#333333] flex justify-between items-center">
        <h1 className="text-2xl font-bold">Yoga Video Editor</h1>
        <div className="flex space-x-4">
          <button onClick={handleExport} className="flex items-center bg-[#E0E0E0] text-[#333333] px-4 py-2 rounded-lg hover:bg-[#D0D0D0] transition-colors">
            <Save size={18} className="mr-2" />
            Export
          </button>

          <button onClick={handlePublish} className="flex items-center bg-[#E0E0E0] text-[#333333] px-4 py-2 rounded-lg hover:bg-[#D0D0D0] transition-colors">
            <Upload size={18} className="mr-2" />
            Publish
          </button>

          <div className="flex space-x-4">
            <label className="flex items-center bg-[#E0E0E0] text-[#333333] px-4 py-2 rounded-lg hover:bg-[#D0D0D0] transition-colors cursor-pointer">
              <Upload size={18} className="mr-2" />
              Import File
              <input type="file" className="hidden" onChange={handleImport} />
            </label>
            
            <button onClick={handleImportLatest} className="flex items-center bg-[#E0E0E0] text-[#333333] px-4 py-2 rounded-lg hover:bg-[#D0D0D0] transition-colors">
              <Upload size={18} className="mr-2" />
              Import Latest
            </button>
          </div>
        </div>




        <div className="flex space-x-4 mt-4">
          {/* Sale Toggle */}
          <label className="flex items-center">
            <input 
              type="checkbox" 
              className="mr-2" 
              checked={isSaleActive} 
              onChange={handleSaleToggle} 
            />
            <span className="text-sm font-bold">Sale Active</span>
          </label>

          {/* Sale Name Input (only show when sale is active) */}
          {isSaleActive && (
            <input 
              type="text" 
              placeholder="Sale Name" 
              value={saleName} 
              onChange={handleSaleNameChange} 
              className="ml-4 px-2 py-1 border rounded"
            />
          )}
        </div>




      </div>
      
      {showAccount ? (
        <AccountPage onBack={eApp_handleBackToCategories(setSelectedVideo, setShowAccount)} />
      ) : selectedVideo ? (
          <VideoPage
            video={selectedVideo}
            categories={categories} // Pass categories
            videos={videos}         // Pass videos
            selectedVideo={selectedVideo} // Pass selectedVideo
            onBack={eApp_handleBackToCategories(setSelectedVideo, setShowAccount)}
            onEdit={(updatedVideo) => eApp_handleEditVideo(
              setVideos,
              selectedVideo,
              setSelectedVideo
            )(
              categories.find(c => videos[c]?.includes(selectedVideo)),
              videos[categories.find(c => videos[c].includes(selectedVideo))].indexOf(selectedVideo),
              updatedVideo
            )}
          />

      ) : (
            <CategoriesPage
              categories={categories}
              videos={videos}
              onSelectVideo={eApp_handleSelectVideo(setSelectedVideo)}
              onSortEnd={handleSortEnd}
              onAccountClick={handleAccountClick}
              onEditVideo={handleEditVideo}  // Pass the handler here
              onAddVideo={eApp_handleAddVideo(setVideos)}
              onDeleteVideo={eApp_handleDeleteVideo(setVideos)}
              onAddCategory={eApp_handleAddCategory(setCategories, setVideos)}
              onDeleteCategory={eApp_handleDeleteCategory(setCategories, setVideos)}
              onReorderCategories={eApp_handleReorderCategories(setCategories)}
              onToggleLockVideo={eApp_handleToggleLockVideo(setVideos)}
              onToggleNewVideo={eApp_handleToggleNewVideo(setVideos)}
              onReorderVideos={eApp_handleReorderVideos(setVideos)}
              lockImageUrl={lockImageUrl}
            />

      )}
    </div>
  );
};


export default EditorApp;
